(function () {
  var root = document.querySelector("[data-newsletter-popup]");
  if (!root || root.getAttribute("data-ready") === "true") return;
  root.setAttribute("data-ready", "true");

  var subscribedKey = "bbb-newsletter-popup-subscribed";
  var dismissedKey = "bbb-newsletter-popup-dismissed";
  var form = root.querySelector("form");
  var closeButton = root.querySelector("[data-newsletter-popup-close]");
  var delay = parseInt(root.getAttribute("data-delay") || "2000", 10);
  var lastFocus = null;

  function storageGet(store, key) {
    try {
      return store.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(store, key, value) {
    try {
      store.setItem(key, value);
    } catch (error) {}
  }

  function subscribed() {
    return storageGet(window.localStorage, subscribedKey) === "1";
  }

  function open() {
    if (subscribed() || storageGet(window.sessionStorage, dismissedKey) === "1") return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add("nlpop-open");
    if (closeButton) closeButton.focus();
  }

  function close(remember) {
    if (remember !== false && !subscribed()) {
      storageSet(window.sessionStorage, dismissedKey, "1");
    }
    root.hidden = true;
    document.documentElement.classList.remove("nlpop-open");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.querySelector("[data-newsletter-popup-backdrop]").addEventListener("click", function () {
    close();
  });
  closeButton.addEventListener("click", function () {
    close();
  });
  function focusable() {
    return Array.prototype.filter.call(
      root.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"),
      function (node) {
        return node.tabIndex >= 0 && node.getClientRects().length > 0;
      }
    );
  }

  document.addEventListener("keydown", function (event) {
    if (root.hidden) return;
    if (event.key === "Escape") {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== "Tab") return;
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (form) {
    form.addEventListener("marketing-signup:success", function () {
      storageSet(window.localStorage, subscribedKey, "1");
      var fields = form.querySelector(".nlpop__fields");
      if (fields) fields.hidden = true;
    });
  }

  window.setTimeout(open, isNaN(delay) ? 2000 : delay);
})();

